import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import SegmentedControl from '@amzn/awsui-components-react/polaris/segmented-control';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import * as React from 'react';
import getOverview from './utils';
import StudySummaryPieChart from '../../../common/chats/pie_chat/StudySummaryPieChart';
import SURVEY_STATUSES from '../../constants/surveyStatuses';

const OverallSurveyStatus = ({ surveysStudySummary, isSurveysStudySummaryLoading }) => {
  const [viewType, setViewType] = React.useState('percentage');

  const getHeader = () => {
    return (
      <Header
        variant="h2"
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <SegmentedControl
              selectedId={viewType}
              onChange={({ detail }) => setViewType(detail.selectedId)}
              options={[
                { text: 'View percentage', id: 'percentage' },
                { text: 'View number', id: 'number' },
              ]}
            />
          </SpaceBetween>
        }
      >
        Overall survey status
      </Header>
    );
  };

  const getPieChart = () => {
    return (
      <StudySummaryPieChart
        aggregation={get(surveysStudySummary, 'aggByStatus', {})}
        aggTypes={SURVEY_STATUSES}
        viewType={viewType}
        isLoading={isSurveysStudySummaryLoading}
        dataValueSuffix="surveys"
      />
    );
  };

  return (
    <Container header={getHeader()}>
      {getOverview(surveysStudySummary, viewType)}
      {getPieChart()}
    </Container>
  );
};

OverallSurveyStatus.propTypes = {
  surveysStudySummary: PropTypes.object,
  isSurveysStudySummaryLoading: PropTypes.bool,
};

OverallSurveyStatus.defaultProps = {
  surveysStudySummary: {},
  isSurveysStudySummaryLoading: false,
};

export default OverallSurveyStatus;
